import React, { Component } from "react";
import MainLayout from "../mainLayout/index";
import FpgMinusIcon from "../icons/fpgminusicon";
import PlusIcon from "../icons/plusicon";
import DraggerIcon from "../icons/draggericon";
import EditIcon from "../icons/EditIcon";
import delet from "../assets/images/delet.svg";
import TextField from "../component/TextField";
import TextEditor from "../component/TextEditor";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { EditorState, convertToRaw, ContentState } from "draft-js";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
//Validation import
import SimpleReactValidator from "simple-react-validator";
import { isEqual, cloneDeep } from "lodash";


//sweet alert
import swal from "sweetalert";

//Service import
import service from "../services";
import Loader from "../component/loader";
import moment from "moment";

let sub;
class ContactUs extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addCatmodal: false,
      title: "",
      description: EditorState.createEmpty(),
      pageTitle: "",
      pageDescription: EditorState.createEmpty(),
      loaderFlag: false,
      isDraggable: false,
      changeSectionsTitleName: false,
      getAllSectionsDetails: [],
      getAllSectionsDocs: [],
      id: "",
      isDraggable: false,
      eventiveId:'',
      showTags:true,
      showFilters:true,
      isContactUsEdited: false,
    };
    this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    this.apiserve = new service();
  }

  normalizeDraftHtml = (editorState) => {
    if (!editorState || typeof editorState === "string") return "";
    const content =
      typeof editorState.getCurrentContent === "function"
        ? editorState.getCurrentContent()
        : null;
    if (!content || !content.hasText()) return "";
    const html = draftToHtml(convertToRaw(content)).trim();
    return html === "<p></p>\n" || html === "<p></p>" || html === "<div></div>"
      ? ""
      : html;
  };

  getCurrentFormData = () => {
    return cloneDeep({
      pageTitle: this.state.pageTitle || "",
      pageDescription: this.normalizeDraftHtml(this.state.pageDescription),
      sections: (this.state.getAllSectionsDocs || []).map((section) => ({
        title: section.title || "",
        description: section.description || "",
      })),
      // Tracking current modal state if it's an edit
      modalTitle: this.state.addCatmodal ? this.state.title || "" : null,
      modalDescription: this.state.addCatmodal ? this.normalizeDraftHtml(this.state.description) : null,
    });
  };

  markContactUsEdited = () => {
    if (this.state.initialData) {
      const isDirty = !isEqual(this.state.initialData, this.getCurrentFormData());
      if (this.state.isContactUsEdited !== isDirty) {
        this.setState({ isContactUsEdited: isDirty });
      }
    }
  };

  updateState = (newState, callback) => {
    this.setState(newState, () => {
      this.markContactUsEdited();
      if (callback) callback();
    });
  };

  AddSection = () => {
    this.validator.hideMessages("");
    this.setState({
      addCatmodal: true,
      title: "",
      description: "",
    }, () => {
        this.setState({ initialData: this.getCurrentFormData(), isContactUsEdited: false });
    });
  };
  CloseModal = () => {
    this.setState({
      addCatmodal: false,
      title: "",
      description: "",
      changeSectionsTitleName: false,
      id: '',
    }, () => {
        this.setState({ initialData: this.getCurrentFormData(), isContactUsEdited: false });
    });
    this.validator.hideMessages("");
  };
  componentDidMount = async () => {
    this.getAllSection();
    this.getquestion();
    this.setState({
      loaderFlag: true,
    });
  };

  componentWillUnmount = () => {
    sub.unsubscribe();
  };

  getquestion = () => {
    sub = this.apiserve.getevent().subscribe((response) => {
      switch (response.event) {
        case "admin|ticketing|contactUs|getlist":
          this.setState(
            {
              getAllSectionsDetails: response.data,
              getAllSectionsDocs: response.data.docs[0].sections,
              pageTitle:response.data.docs[0].title,
              pageDescription:this.getAnwserHtmlToEditor(response.data.docs[0].description)
            },
            () => {
              this.setState({
                loaderFlag: false,
                initialData: this.getCurrentFormData(),
                isContactUsEdited: false
              });
            }
          );
          break;
        case "admin|ticketing|contactUs|sectionInsert":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              addCatmodal: false,
              loaderFlag: false,
              title: "",
              description: "",
              changeSectionsTitleName: false,
            }, () => {
                this.setState({ initialData: this.getCurrentFormData(), isContactUsEdited: false });
            });
            this.apiserve.success("Section added successful.");
          }
          this.getAllSection();
          break;
        case "admin|ticketing|contactUs|sectionEdit":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({
              addCatmodal: false,
              changeSectionsTitleName: false,
              title: "",
              description: "",
              loaderFlag: false
            }, () => {
                this.setState({ initialData: this.getCurrentFormData(), isContactUsEdited: false });
            });
            this.apiserve.success("Section updated Successful.");
          }
          this.getAllSection();
          break;
        case "admin|ticketing|contactUs|Update":
          if (response.error === true) {
            this.setState({
              loaderFlag: false,
              errorMsg: true,
              errorMsgShow: response.data.error,
            });
          } else {
            this.setState({ loaderFlag: false }, () => {
              this.setState({ initialData: this.getCurrentFormData(), isContactUsEdited: false });
            })
            this.apiserve.success("Updated Successful.")
          }
          this.getAllSection();
          break;
        case "admin|ticketing|contactUs|sectionDelete":
          this.getAllSection();
          break;
        case "admin|ticketing|contactUs|sectionChangeOrder":
          break;
      }
    });
  };

  getAllSection = () => {
    this.apiserve.sendevent("admin|ticketing|contactUs|getlist", {});
  };

  onInputChange = (e) => {
    this.updateState({
      [e.target.name]: e.target.value,
    });
  };

  onEditorStateChange = description => {
    this.updateState({
      description
    });
  };

  onEditorStatePageDescriptionChange = pageDescription => {
    this.updateState({
      pageDescription
    });
  };

  submitFn = async (e) => {
    e.preventDefault();
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.description.getCurrentContent());
      const markup = draftToHtml(name);
      if (this.state.changeSectionsTitleName) {
        let updateQue = {
          description: markup,
          title: this.state.title,
          sectionId: this.state.id,
          contactId: this.state.getAllSectionsDetails.docs[0]._id,
        };
        this.apiserve.sendevent("admin|ticketing|contactUs|sectionEdit", updateQue);
      } else {
        let data = {
          description: markup,
          title: this.state.title,
          contactId: this.state.getAllSectionsDetails.docs[0]._id,
        };
        this.apiserve.sendevent("admin|ticketing|contactUs|sectionInsert", data);
      }
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  editSections = async (item) => {
    this.setState({
      addCatmodal: true,
      changeSectionsTitleName: true,
      title: item.title,
      description: this.getAnwserHtmlToEditor(item.description),
      id: item._id,
    }, () => {
        this.setState({ initialData: this.getCurrentFormData(), isContactUsEdited: false });
    });
    this.validator.hideMessages("");
  };

  deleteSections = async (item) => {
    swal({
      title: "Are you sure?",
      text: "You want to delete this record",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        swal("Your record has been deleted!", {
          icon: "success",
        });
        let data = {
          sectionId: item._id,
          contactId: this.state.getAllSectionsDetails.docs[0]._id,
        };
        this.apiserve.sendevent("admin|ticketing|contactUs|sectionDelete", data);
      } else {
        swal("Your record is safe!");
      }
    });
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const { destination, source } = result;
    const oldIndex = source.index;
    const newIndex = destination.index;
    const arr = [...this.state.getAllSectionsDocs];
    if (newIndex >= arr.length) {
      var k = newIndex - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    const updateArr = [];
    arr.forEach(({ _id }, i) => {
      updateArr.push({
        sectionId: _id,
        sortIndex: i + 1,
      });
    });
    this.setState({ isDraggable: true });
    const data = { order: updateArr };
    this.apiserve.sendevent("admin|ticketing|contactUs|sectionChangeOrder", data);
    this.setState({ getAllSectionsDocs: arr });
  };

  getAnwserHtmlToEditor = (html) => {
    const fieldValue = html ?? '';
    const blocksFromHtml = htmlToDraft(fieldValue);
    const { contentBlocks, entityMap } = blocksFromHtml;
    const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
    const editorState = EditorState.createWithContent(contentState);
    return editorState;
  }

  validateModel = () => {
    this.setState({
      errorMsg: false,
    });
  };

  submit = async (e) => {
    e.preventDefault();
    console.log(this.validator,"this.validator");
    
    if (this.validator.allValid()) {
      this.setState({ loaderFlag: true });
      const name = convertToRaw(this.state.pageDescription.getCurrentContent());
      const markup = draftToHtml(name);
      let data = {
        description: markup,
        title: this.state.pageTitle,
        contactId: this.state.getAllSectionsDetails.docs[0]._id,
        sections:this.state.getAllSectionsDetails.docs[0].sections.map(item => ({title:item.title, description:item.description}))
      };
      this.apiserve.sendevent("admin|ticketing|contactUs|Update", data);
    } else {
      this.validator.showMessages();
      this.forceUpdate();
    }
  };

  render() {
    const { getAllSectionsDocs, changeSectionsTitleName } = this.state;
    return (
      <React.Fragment>
        <div className="ticketing_faq_page">
          <div className="ticketing_content fpg_tabcontent pb_25">
            <div className="ticketing_wrapper">
              <div className="field_row horizontal_field">
                <TextField
                  type="text"
                  label="Title"
                  name="pageTitle"
                  value={this.state.pageTitle}
                  onChange={this.onInputChange}
                  fpgerror={this.validator.message('pageTitle', this.state.pageTitle, 'required')}
                />
              </div>
              <div className="field_row horizontal_field">
                <div className="field_row_inner">
                  <label>Description</label>
                  <div className="field_input relative editor_wrapper">
                    <TextEditor
                      name="pageDescription"
                      editorState={this.state.pageDescription}
                      value={this.state.pageDescription}
                      onEditorStateChange={e => this.onEditorStatePageDescriptionChange(e)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="dashboard_header with_btn pl_15">
              <div className="searchBlock">
                <span>Sections</span>
              </div>
              <div className="button_block admin_user_twoBtn">
                <button className="head_btn pointer no_border" style={{width: "130px"}} onClick={() => this.AddSection()}><PlusIcon /> &nbsp; Add Section</button>
              </div>
            </div>
            <div className="category_add_edit">
              <div className="table_wrap product_list_tbl film_list_table striped_table">
              <table>
                <thead>
                <tr>
                  <th></th>
                  <th>Title</th>
                  <th>Description</th>
                  <th>Last Updated Date (MT)</th>
                  <th>Updated By (MT)</th>
                  <th> </th>
                </tr>
                </thead>
                  <DragDropContext onDragEnd={this.onDragEnd}>
                    <Droppable droppableId="droppable">
                      {(provided, snapshot) => (
                        <tbody {...provided.droppableProps} ref={provided.innerRef}>
                          {getAllSectionsDocs?.map((item, index) => (
                            <Draggable
                              key={item._id}
                              draggableId={item._id}
                              index={index}
                            >
                              {(provided, snapshot) => (
                                <tr
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                >
                                  <td>
                                    <DraggerIcon />
                                  </td>
                                  <td>{item.title}</td>
                                  <td><div class="display_name" dangerouslySetInnerHTML={{__html:item.description}} /></td>
                                  <td>{item.lastUpdated ? moment.tz(item.lastUpdated, "US/Mountain").format("MM/DD/YYYY") : '-'}</td>
                                  <td>{item.updatedBy && item.updatedBy.fname} {item.updatedBy && item.updatedBy.lname}</td>
                                  <td>
                                    <div className="action_wrap d_flex">
                                      <span className="cat_edit pointer" onClick={() => this.editSections(item)} >
                                        <EditIcon />
                                      </span>
                                      <span className="remove_cat pointer" onClick={() => this.deleteSections(item)} >
                                        <img src={delet} alt="delet" />
                                      </span>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </Draggable>
                          ))}
                        </tbody>
                      )}
                    </Droppable>
                  </DragDropContext>
                  </table>
              </div>
            </div>
          </div>
          <div className={`user_popup ${this.state.addCatmodal ? "active" : ""}`} >
            <span className="popup_overlay" onClick={this.CloseModal}></span>
            <div className="cat_modal_inner">
              <p className="cat_title text_center">
                {changeSectionsTitleName ? "Edit Section" : "Add Section"}
              </p>
              <form>
                <div className="field_row horizontal_field d_flex">
                  <TextField
                    type="text"
                    label="Title"
                    name="title"
                    value={this.state.title}
                    onChange={this.onInputChange}
                  />
                </div>
                <div className="field_row horizontal_field d_flex">
                  <div className="field_row_inner">
                    <label>description</label>
                    <div className="field_input relative editor_wrapper">
                      <TextEditor
                        name="description"
                        editorState={this.state.description}
                        value={this.state.description}
                        onEditorStateChange={e => this.onEditorStateChange(e)}
                      />
                    </div>
                  </div>
                </div>
                <div className="cat_btns text_center">
                  <button type="button" onClick={this.CloseModal}>
                    CANCEL
                  </button>
                  <button disabled={this.state.loaderFlag || (this.state.id ? !this.state.isContactUsEdited : false)} className={`${this.state.loaderFlag || (this.state.id ? !this.state.isContactUsEdited : false) ? '' : "active"}`} onClick={(e) => this.submitFn(e)}>
                    SAVE
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        <div className="text_center field_row w_100 buttons_outer mt_25">
          <button className="uppercase" onClick={this.cancelBTN}>
            CANCEL
          </button>
          {/* <button className="uppercase prev_btn">PREviEW</button> */}
          <button disabled={this.state.loaderFlag || (this.state.getAllSectionsDetails.docs && this.state.getAllSectionsDetails.docs.length > 0 ? !this.state.isContactUsEdited : false)} className={`uppercase ${this.state.loaderFlag || (this.state.getAllSectionsDetails.docs && this.state.getAllSectionsDetails.docs.length > 0 ? !this.state.isContactUsEdited : false) ? '' : 'active'}`} type="button" onClick={e => this.submit(e)}>
            SAVE
          </button>
        </div>
        <div className={`user_popup ${this.state.errorMsg ? "active" : ""}`}>
          <span className="popup_overlay"></span>
          <div className="sundance_popup_detail box_shadow approve_success_popup bg_white">
            <div className="approve_popup_header text_center relative">
              <p>{this.state.errorMsgShow}</p>
            </div>
            <div className="content">
              <div className="field_row text_center">
                <button
                  className="small_btn active"
                  onClick={this.validateModel}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
        </div>
        {this.state.loaderFlag ? <Loader /> : ""}
      </React.Fragment>
    );
  }
}

export default ContactUs;
